// src/features/sales/components/DistinctSaleTable.js
import DistinctSaleRow from "./DistinctSaleRow";

export default function DistinctSaleTable({ sales, loading }) {
  if (loading) {
    return (
      <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
        <div className="h-5 w-32 bg-gray-100 rounded mb-4" />
        <div className="space-y-2">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="h-12 bg-gray-50 rounded-xl" />
          ))}
        </div>
      </div>
    );
  }

  if (!sales?.length) {
    return (
      <div className="rounded-2xl border border-gray-200 bg-white p-10 text-center text-gray-500 shadow-sm">
        No sales summary found.
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
      {/* Desktop table */}
      <div className="hidden md:block">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50/60">
            <tr>
              <Th>Main Company</Th>
              <Th>YearMonth</Th>
              <Th className="text-right">Tx Count</Th>
              <Th className="text-right">Qty</Th>
              <Th className="text-right">Sales</Th>
              <Th className="text-right">Net Sales</Th>
              <Th className="text-right">PPN</Th>
              <Th className="text-right">Debet</Th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {sales.map((row) => (
              <DistinctSaleRow key={row.id} sale={row} />
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <ul className="md:hidden divide-y divide-gray-100">
        {sales.map((row) => (
          <li key={row.id} className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium text-gray-900">
                  {row.main_company || "—"}
                </div>
                <div className="text-xs text-gray-500">
                  {row.yearMonth || "—"}
                </div>
              </div>
              <div className="text-right text-sm text-gray-700">
                <div className="font-semibold">
                  Net: {formatNumber(row.net_sales)}
                </div>
                <div className="text-xs text-gray-500">
                  Debet: {formatNumber(row.debet)}
                </div>
              </div>
            </div>
            <div className="mt-2 text-xs text-gray-500 flex flex-wrap gap-3">
              <span>Tx: {row.transaction_count ?? "—"}</span>
              <span>Qty: {formatQty(row.quantity)}</span>
              <span>PPN: {formatNumber(row.ppn)}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

function Th({ children, className = "" }) {
  return (
    <th
      className={`px-6 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 ${className}`}
    >
      {children}
    </th>
  );
}

// small local helpers so mobile cards can format too
function formatNumber(value) {
  if (value === null || value === undefined || value === "") return "—";
  const num = Number(value);
  if (Number.isNaN(num)) return "—";
  return num.toLocaleString("id-ID", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function formatQty(value) {
  if (value === null || value === undefined || value === "") return "—";
  const num = Number(value);
  if (Number.isNaN(num)) return "—";
  return num.toLocaleString("id-ID", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}
